"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _isReady = require("./isReady");
Object.keys(_isReady).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isReady[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isReady[key];
    }
  });
});